export default __webpack_public_path__ + "static/media/copy.dd199bb7.svg";